import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const CalendarDaily = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <defs>
        <path
          id="calendar-daily-path-1"
          d="M16 4c.342 0 .624.257.662.589l.005.078-.001.666H18a2 2 0 011.995 1.851l.005.15V18a2 2 0 01-2 2H6a2 2 0 01-2-2V7.333a2 2 0 012-2h1.333v-.666a.667.667 0 011.33-.078l.004.078-.001.666h6.667v-.666c0-.369.299-.667.667-.667zm2.666 7.333H5.333V18c0 .335.247.612.568.66l.099.007h12a.667.667 0 00.667-.667l-.001-6.667zM7.333 6.666H6a.667.667 0 00-.667.667V10h13.333V7.333a.667.667 0 00-.567-.66L18 6.668l-1.334-.001V8a.667.667 0 01-1.328.078L15.333 8V6.666H8.666V8a.667.667 0 01-1.328.078L7.333 8V6.666z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <mask id="calendar-daily-mask-2" fill="#fff">
            <use xlinkHref="#calendar-daily-path-1"></use>
          </mask>
          <use
            fill="#FFF"
            fillRule="nonzero"
            xlinkHref="#calendar-daily-path-1"
          ></use>
          <g
            fill={props.color || theme.palette.grey600}
            mask="url(#calendar-daily-mask-2)"
          >
            <g>
              <path d="M0 0H24V24H0z"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
